import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { CommonUserService } from 'src/sb-tools/typescript/services/common-user.service';
import { forkJoin } from 'rxjs';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';
import { CustomerConfigurationService } from '../core/services/customer-configuration.service';
import { resolveIsOnlyMyTicketsFilterDefault } from './utils/resolve-default-ticket-filter.util';

@Injectable()
export class RedirectToMyTicketsGuard implements CanActivate {
    constructor(
        private router: Router,
        private commonUserService: CommonUserService,
        private customerConfigurationService: CustomerConfigurationService,
    ) {}

    canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot): boolean {
        if (Object.keys(activatedRouteSnapshot.queryParams).length === 0) {
            forkJoin([this.commonUserService.getFullInfo(), this.customerConfigurationService.get()]).subscribe(
                (results) => {
                    const user = results[0];
                    const customerSettings = results[1];

                    this.router.navigate([activatedRouteSnapshot.params.communityName, 'tickets'], {
                        queryParams: {
                            onlyMy: resolveIsOnlyMyTicketsFilterDefault(user, customerSettings as any),
                            status: TicketStatus.open,
                        },
                    });
                    return false;
                },
            );
        } else {
            return true;
        }
    }
}
